import { autoinject } from 'aurelia-framework';

import { EntityType } from '~/models/entities/entity-type';
import { FieldModel } from '~/models/form-model';
import { SearchResponse } from '~/models/search-response';
import { FetchUtils } from '~/utils/fetch-utils';

export interface InvestmentManagerSearchResult {
	entityType: EntityType.INVESTMENT_MANAGER;
	values: InvestmentManagerSearchValuesBackend;
	fieldModel?: InvestmentManagerFieldModels;
}

export interface InvestmentManagerResult {
	entityType: EntityType.INVESTMENT_MANAGER;
	values: InvestmentManagerValuesBackend;
	fieldModel?: InvestmentManagerFieldModels;
}

interface InvestmentManagerFieldModels {
	IMz_AAS25_Grouping?: FieldModel;
	IMz_Status?: FieldModel;
	IMz_Group?: FieldModel;
}

interface InvestmentManagerSearchValuesBackend {
	IMi_Identity: string;
	IMz_Code: string;
	IMz_Name: string; // ie. "IM 00"
	IMz_Long_Code: string;
	IMz_Group: string; // ie. "AM"
	IMz_Status: string; // ie. "IF"
	IMz_AAS25_Grouping: string;
}

// NOTE: Jake: 2019-08-02 - WEBUI-2311
// This might seem redundant, but the "getInvestmentManager" endpoint might be extended in the future
// to return more fields (ie. like "PayrollDetailsEmployerResultBackend" or "MemberResourceBackend")
type InvestmentManagerValuesBackend = InvestmentManagerSearchValuesBackend;

@autoinject
export class InvestmentManagerSearchApi {
	private static readonly RESOURCE_PATH = 'api/investment-manager-details';

	public getSearchResults(
		query: string,
	): Promise<SearchResponse<InvestmentManagerSearchResult>> {
		return FetchUtils.getJSON<
			SearchResponse<InvestmentManagerSearchResult>
		>(InvestmentManagerSearchApi.RESOURCE_PATH + '/search', {
			q: query,
			'field-model': true,
		}).then((response) => {
			for (const item of response.data) {
				item.entityType = EntityType.INVESTMENT_MANAGER;
			}
			return response;
		});
	}

	public getInvestmentManager(
		code: string,
	): Promise<InvestmentManagerResult> {
		return FetchUtils.getJSON<InvestmentManagerResult>(
			InvestmentManagerSearchApi.RESOURCE_PATH + '/getByCode/' + code,
		).then((data) => {
			data.entityType = EntityType.INVESTMENT_MANAGER;
			return data;
		});
	}
}
